import * as React from 'react';
import classNames from 'classnames';
import { Link, useTranslation } from 'gatsby-plugin-react-i18next';
import { Helmet } from 'react-helmet';
import { Button } from '../ui/button/button';
import { useNavigationLinks } from '../../hooks/useNavigationLinks';
import './footer.scss';

export const Footer: React.FC = () => {
  const { t } = useTranslation();
  const navLinks = useNavigationLinks();

  return (
    <div className="container--fluid">
      <footer className="footer">
        <nav className="footer__nav">
          <ul className="footer__nav-list">
            {navLinks.map(({ name, isActive, url }) => (
              <li key={name} className="footer__nav-list-item">
                <Link
                  className={classNames('footer__nav-list-link', {
                    'footer__nav-list--active': isActive,
                  })}
                  to={url}
                >
                  {name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <div className="footer__info">
          <h3>{t('pages.home.title')}</h3>
          <Button
            text={t('buttons.foundations.name')}
            link={t('buttons.foundations.url')}
            variant="small"
          />
        </div>
      </footer>
      <Helmet>
        <script async src="https://platform-api.sharethis.com/js/sharethis.js#property=62239104a9cb560012eb921a&product=sticky-share-buttons" />
      </Helmet>
    </div>
  );
};
